import logger from '@/lib/logger'
import type { NodeData } from '@/lib/three/types'
import type { ImpiantoDTO, NuovoImpiantoDTO } from '@/models/dto/impianto/impianto-dto'
import type { Facility, NewFacility } from '@/models/types/facility/facility'
import { mapToFacilityStatus, mapToStatoImpianto } from './facility-status-mapper'

const mapToFacility = (impiantiDTO: ImpiantoDTO): Facility => {
    return { ...mapToNewFacility(impiantiDTO), id: impiantiDTO.id }
}

const mapToImpiantoDTO = (facility: Facility): ImpiantoDTO => {
    return { ...mapToNuovoImpiantoDTO(facility), id: facility.id }
}

const mapToNewFacility = (impiantiDTO: NuovoImpiantoDTO): NewFacility => {
    let ifcConfigurationData: NodeData[] | undefined
    try {
        ifcConfigurationData = impiantiDTO.ifcMetadata ? (JSON.parse(impiantiDTO.ifcMetadata) as NodeData[]) : []
    } catch (error) {
        logger.error('Errore nel parsing dei metadata ifc:')
        logger.log(ifcConfigurationData)
    }

    return {
        name: impiantiDTO.nome ?? undefined,
        address: impiantiDTO.indirizzo ?? undefined,
        city: impiantiDTO.città ?? undefined,
        province: impiantiDTO.provincia ?? undefined,
        postalCode: impiantiDTO.cap ?? undefined,
        latitude: impiantiDTO.latitudine ?? undefined,
        longitude: impiantiDTO.longitudine ?? undefined,
        enabled: impiantiDTO.attivo ?? undefined,
        description: impiantiDTO.descrizione ?? undefined,
        status: mapToFacilityStatus(impiantiDTO.statoImpianto),
        blueprintPath: impiantiDTO.file2DStoragePath,
        blueprintUrl: impiantiDTO.file2DUrl,

        blueprintPaths: impiantiDTO.listFile2DStoragePath ?? undefined,
        blueprintUrls: impiantiDTO.listFile2DUrl ?? undefined,

        iconPath: impiantiDTO.iconStoragePath,
        iconUrl: impiantiDTO.iconUrl,
        model3dPath: impiantiDTO.bimBlobStoragePath,
        model3dUrl: impiantiDTO.bimUrl,
        plcIds: impiantiDTO.idPlc ?? undefined,
        photovoltaicIds: impiantiDTO.idFotovoltaico ?? undefined,
        BMSIds: impiantiDTO.idBMS ?? undefined,
        notificationEmail: impiantiDTO.mailNotifica ?? undefined,
        mailNotificaAutomatica: impiantiDTO.mailNotificaAutomatica ?? false,
        ifcConfigurationRawData: impiantiDTO.ifcMetadata ?? undefined,
        ifcConfigurationData,
    }
}

const mapToNuovoImpiantoDTO = (facility: NewFacility): NuovoImpiantoDTO => {
    return {
        nome: facility.name,
        indirizzo: facility.address,
        città: facility.city,
        provincia: facility.province,
        cap: facility.postalCode,
        latitudine: facility.latitude,
        longitudine: facility.longitude,
        attivo: facility.enabled,
        descrizione: facility.description,
        statoImpianto: mapToStatoImpianto(facility.status),
        iconUrl: facility.iconUrl,
        iconStoragePath: facility.iconPath,
        file2DUrl: facility.blueprintUrl ?? '',
        file2DStoragePath: facility.blueprintPath ?? '',
        bimUrl: facility.model3dUrl,
        bimBlobStoragePath: facility.model3dPath,
        idPlc: facility.plcIds ?? null,
        idFotovoltaico: facility.photovoltaicIds ?? null,
        idBMS: facility.BMSIds ?? null,
        mailNotifica: facility.notificationEmail ?? null,
        mailNotificaAutomatica: facility.mailNotificaAutomatica ?? null,
        ifcMetadata: facility.ifcConfigurationRawData ?? null,

        listFile2DUrl: facility.blueprintUrls ?? null,
        listFile2DStoragePath: facility.blueprintPaths ?? null,
    }
}

export { mapToFacility, mapToImpiantoDTO, mapToNewFacility, mapToNuovoImpiantoDTO }
